// extracted by mini-css-extract-plugin
export default {"dots_container":"Loader_dots_container__2eiVZ","dot":"Loader_dot__MWItN"};